module.exports = __webpack_public_path__ + "static/media/icon_chevron_big.ad1942e6.svg";